var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"right"}},[_c('v-slider',{attrs:{"min":150,"max":600,"step":50,"label":"Image Size","value":_vm.value},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }